import { useTranslation } from 'react-i18next'
import { UnsubscribedImage } from '../agent-creation/assets/unsubscribed-icon';

/** 智能体未订阅页 */
export const UnSubscribePage = () => {
  const { t } = useTranslation()

  return (
    <div className="w-full h-full flex items-center justify-center flex-col gap-4">
      <UnsubscribedImage className="w-[16rem] h-[10rem]" />
      <div className="text-2xl font-semibold text-[rgba(16,24,40,1)]">
        {t("agent_creation.unsubscribed.title")}
      </div>
      <div className="text-sm text-[rgba(102,112,133,1)]">
        {t("agent_creation.unsubscribed.description")}
      </div>
      <button
        className="flex justify-center items-center gap-2 px-4 py-2.5 text-white text-medium bg-i-normal shadow-[0px_1px_2px_rgba(16,24,40,0.05)] rounded-sm hover:bg-[rgba(40,47,62,1)] transition-all duration-200 h-10 text-sm font-semibold"
        onClick={() => {
          window.open("mailto:support@bizdesk.ai");
        }}
      >
        {t("agent_creation.unsubscribed.contact")}
      </button>
    </div>
  )
}
